(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["SNDR-best-cycling-glasses-v1"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Delegation survives Shopify's section reloads without stale per-section listeners.
  if (window.sndrComparisonInstalled) return;
  window.sndrComparisonInstalled = true;
  const parameters = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];

  function initialize(container) {
    const roots = container.matches?.('[data-sndr-comparison]')
      ? [container] : container.querySelectorAll('[data-sndr-comparison]');
    roots.forEach(root => {
      if (root.dataset.passTracking !== 'true') return;
      const incoming = new URLSearchParams(window.location.search);
      root.querySelectorAll('a[href]').forEach(link => {
        try {
          const url = new URL(link.getAttribute('href'), window.location.href);
          const sndrProduct = /(^|\.)sndroptics\.com$/.test(url.hostname) && url.pathname.startsWith('/products/');
          if (!link.hasAttribute('data-sndr-cta') && !sndrProduct) return;
          if (!['https:', 'http:'].includes(url.protocol)) return;
          parameters.forEach(key => {
            if (incoming.has(key)) url.searchParams.set(key, incoming.get(key));
          });
          link.href = url.toString();
        } catch (_) {
          // An unfinished editor URL must not break the rest of the page.
        }
      });
    });
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-sndr-open]');
    if (trigger) {
      const root = trigger.closest('[data-sndr-comparison]');
      const dialog = root?.querySelector('dialog');
      if (dialog && !dialog.open) dialog.showModal();
    }
    const dialog = event.target.closest('dialog.disclosure-dialog');
    if (dialog && event.target === dialog && dialog.closest('[data-sndr-comparison]')) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();


  } catch(e) { console.error(e); }
})();
})();
